import { render, staticRenderFns } from "./WithdrawReport.vue?vue&type=template&id=23fa4cd7&"
import script from "./WithdrawReport.vue?vue&type=script&lang=js&"
export * from "./WithdrawReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports